// extracted by mini-css-extract-plugin
module.exports = {"screen":"screen__2yEp5","article":"article__13kg6"};